import React from 'react'
import cx from 'classnames'
import { l } from '@manychat/manyui'

import { useThemeContext } from '../../useThemeContext'

import cm from './Message.module.css'

export interface OutgoingStoryMessageProps {
  variant: 'outgoing-story'
  imageUrl?: string
  placeholderText?: string
  reaction?: string
  hasLike?: boolean
  id?: string
}

export const OutgoingStoryMessage = React.forwardRef<
  HTMLDivElement,
  Omit<OutgoingStoryMessageProps, 'variant'>
>((props, ref) => {
  const theme = useThemeContext()

  return (
    <>
      {props.imageUrl && (
        <div className={cm.messageStoryTop}>{l.translate('You replied to their story')}</div>
      )}
      <div
        ref={ref}
        className={cx('p-relative p-0', cm.message, cm.outgoing, cm.messageStory, cm[theme], {
          ['m-b-sm']: props.hasLike,
        })}
        data-test-id="outgoing-story-message"
        id={props.id}
      >
        {props.imageUrl ? (
          <img src={props.imageUrl} className={cm.messageStorImage} />
        ) : (
          <div className={cm.messageStorImage}>{props.placeholderText}</div>
        )}
        {props.reaction && <div className={cm.messageReaction}>{props.reaction}</div>}
        {props.hasLike && <div className={cm.messageLike}>❤️</div>}
      </div>
    </>
  )
})
